import React from "react"
import { blogPosts } from "../contexts/BlogContext"
import { useLanguage } from "../contexts/LanguageContext"
import "../styles/BlogSection.css"
import { useNavigate } from "react-router-dom"

const BlogSection = () => {
  const { language } = useLanguage()
  const isRtl = language === "he"
  const navigate = useNavigate ? useNavigate() : (url) => { window.location.href = url }

  return (
    <section className={`blog-section${isRtl ? " rtl-text" : ""}`} id="blog">
      <h2 className="blog-title">
        {language === "he" ? "בלוג תיירות" : language === "fr" ? "Blog Tourisme" : language === "es" ? "Blog de Turismo" : "Tourism Blog"}
      </h2>
      <div className="blog-cards">
        {blogPosts.slice(0, 3).map((post) => (
          <div className="blog-card" key={post.id}>
            <a 
              href={`/blog/${post.id}`} 
              className="blog-card-link"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/blog/${post.id}`);
              }}
              aria-label={post.title[language]}
            >
              <img src={post.image} alt={post.title[language]} className="blog-image" />
              <div className="blog-card-content">
                <h3 className="blog-card-title">{post.title[language]}</h3>
                <p className="blog-card-summary">{post.summary[language]}</p>
                <button
                  className="blog-readmore-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/blog/${post.id}`);
                  }}
                  aria-label={language === "he" ? "קרא עוד" : language === "fr" ? "Lire plus" : language === "es" ? "Leer más" : "Read more"}
                >
                  {language === "he" ? "קרא עוד" : language === "fr" ? "Lire plus" : language === "es" ? "Leer más" : "Read more"}
                </button>
              </div>
            </a>
          </div>
        ))}
      </div>
      <div className="blog-viewall-container">
        <button
          className="blog-viewall-btn"
          onClick={() => navigate("/blog")}
          aria-label={language === "he" ? "הצג עוד" : language === "fr" ? "Voir plus" : language === "es" ? "Ver más" : "See more"}
        >
          {language === "he" ? "הצג עוד" : language === "fr" ? "Voir plus" : language === "es" ? "Ver más" : "See more"}
        </button>
      </div>
    </section>
  )
}

export default BlogSection
